class StickyHeader extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this.isTicking = false
    this.lastKnownY = window.scrollY
    this.offsetTrackedY = 0
    this.scrollOffset = 50
    this.safeZone = 100
    this.scrollDirection = ''
  }

  setupListeners () {
    super.setupListeners()

    this.requestTick = this.requestTick.bind(this)
    this.updateEl = this.updateEl.bind(this)
    this.onScroll = this.onScroll.bind(this)

    window.addEventListener('scroll', this.onScroll, { passive: true })
  }

  onScroll () {
    const previouslyKnown = this.lastKnownY
    const previousDirection = this.scrollDirection

    this.lastKnownY = window.scrollY
    this.scrollDirection = previouslyKnown < this.lastKnownY ? 'down' : 'up'

    if (previousDirection !== this.scrollDirection) {
      this.offsetTrackedY = this.lastKnownY
    }

    this.requestTick()
  }

  requestTick () {
    if (!this.isTicking) requestAnimationFrame(this.updateEl)

    this.isTicking = true
  }

  updateEl () {
    this.isTicking = false

    this.setScrolled()
    this.setScrolledUp()
  }

  setScrolled () {
    this.classList.toggle(this.dataset.classScrolled, this.hasScrolled)
    document.body.classList.toggle('lyt-Theme-scrolled', this.hasScrolled)
  }

  setScrolledUp () {
    this.classList.toggle(this.dataset.classScrolledUp, this.hasScrolledUp)
    document.body.classList.toggle('lyt-Theme-scrolledUp', this.hasScrolledUp)
  }

  get bodyElement () {
    return document.body
  }

  get hasScrolled () {
    return this.lastKnownY >= this.safeZone
  }

  get hasScrolledUp () {
    return (
      this.scrollDirection === 'up' &&
      this.lastKnownY >= this.safeZone &&
      this.lastKnownY <= this.offsetTrackedY - this.scrollOffset
    )
  }
}

if (!customElements.get('sticky-header')) {
  customElements.define('sticky-header', StickyHeader)
}
